import { render } from "./IconInstock.vue?vue&type=template&id=5f00d34a"
import script from "./IconInstock.vue?vue&type=script&lang=ts"
export * from "./IconInstock.vue?vue&type=script&lang=ts"
script.render = render

export default script